/* ============================================================
   Reviews Carousel — native flex-scroller controls
   1:1 port of the prototype's scroll logic (no Swiper):
     • prev/next scroll by one card width + gap
     • prev disabled at the start, next disabled at the end
   Multi-instance + Shopify-editor safe. No globals leaked (IIFE).
   ============================================================ */
(function () {
  'use strict';

  if (window.__reviewsCarousel) {
    window.__reviewsCarousel.initAll();
    return;
  }

  function scrollAmount(track) {
    var card = track.querySelector('.rc-card');
    var styles = getComputedStyle(track);
    var gap = parseInt(styles.columnGap || styles.gap || '20', 10) || 20;
    return card ? card.offsetWidth + gap : 340;
  }

  /*
   * Scroll geometry is physical, and CSS logical properties cannot fix it.
   * In an RTL scroll container the spec-compliant `scrollLeft` starts at 0 at
   * the right edge and grows NEGATIVE toward the end, so every raw comparison
   * and delta below silently inverts: the "next" button would be born
   * disabled and clicking it would scroll away from the remaining cards.
   *
   * Direction is read from computed style rather than the locale, so this
   * follows whatever <html dir> inherits down and needs no locale list.
   */
  function isRTL(track) {
    return getComputedStyle(track).direction === 'rtl';
  }

  /* Distance travelled from the start edge, direction-agnostic. */
  function scrolled(track) {
    return Math.abs(track.scrollLeft);
  }

  function updateNav(root) {
    var track = root.querySelector('[data-rc-track]');
    if (!track) return;
    var prev = root.querySelector('[data-rc-prev]');
    var next = root.querySelector('[data-rc-next]');
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = scrolled(track) <= 2;
    if (next) next.disabled = scrolled(track) >= max;
  }

  function initOne(root) {
    if (!root) return;
    var track = root.querySelector('[data-rc-track]');
    if (!track) return;

    var prev = root.querySelector('[data-rc-prev]');
    var next = root.querySelector('[data-rc-next]');

    /* scrollBy takes a PHYSICAL delta, so "forward" is negative in RTL. */
    if (prev) {
      prev.addEventListener('click', function () {
        var step = scrollAmount(track);
        track.scrollBy({ left: isRTL(track) ? step : -step, behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        var step = scrollAmount(track);
        track.scrollBy({ left: isRTL(track) ? -step : step, behavior: 'smooth' });
      });
    }
    track.addEventListener('scroll', function () { updateNav(root); }, { passive: true });
    updateNav(root);
  }

  function initAll() {
    document.querySelectorAll('.reviews-carousel').forEach(initOne);
  }

  function updateAll() {
    document.querySelectorAll('.reviews-carousel').forEach(updateNav);
  }

  window.__reviewsCarousel = { initAll: initAll, initOne: initOne };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* one global resize listener recalculates every instance */
  window.addEventListener('resize', updateAll);

  /* Shopify theme editor: (re)init the loaded section */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.reviews-carousel');
    if (root) initOne(root);
  });
})();
